export const ConfirmDialog = (id, title, msg, $true, $false, callback) => { /*change*/

    const style = document.createElement('style');
    style.id = `cd-dialogStyle${id}`;
    style.type = 'text/css';
    style.textContent = `
    .cd-dialog-ovelay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.50);
    z-index: 999999
}

.cd-dialog-ovelay .cd-dialog {
    width: 400px;
    margin: 100px auto 0;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, .2);
    border-radius: 3px;
    overflow: hidden
}

.cd-dialog-ovelay .cd-dialog .cd-header {
    padding: 10px 8px;
    background-color: #f6f7f9;
    border-bottom: 1px solid #e5e5e5
}

.cd-dialog-ovelay .cd-dialog .cd-header h3 {
    font-size: 14px;
    margin: 0;
    color: #555;
    display: inline-block
}

.cd-dialog-ovelay .cd-dialog .cd-header .fa-close {
    float: right;
    color: #c4c5c7;
    cursor: pointer;
    transition: all .5s ease;
    padding: 0 2px;
    border-radius: 1px
}

.cd-dialog-ovelay .cd-dialog .cd-header .fa-close:hover {
    color: #b9b9b9
}

.cd-dialog-ovelay .cd-dialog .cd-header .fa-close:active {
    box-shadow: 0 0 5px #673AB7;
    color: #a2a2a2
}

.cd-dialog-ovelay .cd-dialog .cd-dialog-msg {
    padding: 12px 10px
}

.cd-dialog-ovelay .cd-dialog .cd-dialog-msg p {
    margin: 0;
    font-size: 15px;
    color: #333
}

.cd-dialog-ovelay .cd-dialog .cd-footer {
    border-top: 1px solid #e5e5e5;
    padding: 8px 10px
}

.cd-dialog-ovelay .cd-dialog .cd-footer .cd-controls {
    direction: rtl
}

.cd-dialog-ovelay .cd-dialog .cd-footer .cd-controls .button {
    padding: 5px 15px;
    border-radius: 3px
}
    .button {
    cursor: pointer
}

.button-default {
    background-color: rgb(248, 248, 248);
    border: 1px solid rgba(204, 204, 204, 0.5);
    color: #5D5D5D;
}

.button-danger {
    background-color: #f44336;
    border: 1px solid #d32f2f;
    color: #f5f5f5
}
`;
    if (!document.getElementById('cd-dialogStyle')) {
        document.head.appendChild(style);
    }


    var $content = "<div class='cd-dialog-ovelay'>" +
        "<div class='cd-dialog'><div class='cd-header'>" +
        " <h3> " + title + " </h3> " +
        "<i class='fa fa-close'></i>" +
        "</div>" +
        "<div class='cd-dialog-msg'>" +
        " <p> " + msg + " </p> " +
        "</div>" +
        "<div class='cd-footer'>" +
        "<div class='cd-controls'>" +
        " <button class='button button-danger doAction'>" + $true + "</button> " +
        " <button class='button button-default cancelAction'>" + $false + "</button> " +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>";
    //$('body').prepend($content);
    var body = document.body;
    var span = document.createElement("span");
    span.id = `cd-dialog-ovelay${id}`;
    span.innerHTML = $content;
    body.prepend(span);

    const doActionBtn = document.querySelectorAll('.doAction');
    const closeActionBtn = document.querySelectorAll('.cancelAction, .fa-close');

    doActionBtn.forEach(element => {
        element.addEventListener('click', function (event) {
            //window.open($link, "_blank"); 
            if (callback) {
                callback(true);
            }
            document.querySelectorAll(`#cd-dialog-ovelay${id}`).forEach(el => el.remove());
            /*  if (document.getElementById('cd-dialogStyle')) {
                 document.querySelectorAll(".cd-dialogStyle").forEach(el => el.remove());
             } */
        });
    });
    closeActionBtn.forEach(element => {
        element.addEventListener('click', function (event) {
            if (callback) {
                callback(false);
            }
            document.querySelectorAll(`#cd-dialog-ovelay${id}`).forEach(el => el.remove());
        });
        /* if (document.getElementById('cd-dialogStyle')) {
            document.querySelectorAll(".cd-dialogStyle").forEach(el => el.remove());
        } */
    });

}


// WEBPACK FOOTER //
// ./src/components/Misc/confirmDialog/index.js